// Identificadores do anúncio do Meta (fbc e fbp) que o site repassa à versão web quando a pessoa
// clica em "Usar no navegador" (AC-250): ficam no navegador por até 90 dias e vão junto ao pedir o
// checkout, para o servidor avisar o Meta da assinatura (AC-249, Privacidade 8.11). Nenhum script
// do Meta roda no app — só estes dois textos passam adiante.

export interface AdIds {
  fbc?: string;
  fbp?: string;
}

const KEY = 'bdi-ad';
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
const FB_ID = /^fb\.\d\.\d{10,16}\.[\w.-]{1,200}$/;

const valid = (v: string | null | undefined): string | undefined => (v && FB_ID.test(v) ? v : undefined);

/** Lê `_fbc`/`_fbp` do endereço, guarda e tira os dois da barra de endereços. */
export function captureAdIds(href: string, storage: Pick<Storage, 'getItem' | 'setItem'>, replaceUrl: (url: string) => void, now = Date.now()): void {
  const url = new URL(href);
  if (!url.searchParams.has('_fbc') && !url.searchParams.has('_fbp')) return;
  const fbc = valid(url.searchParams.get('_fbc'));
  const fbp = valid(url.searchParams.get('_fbp'));
  url.searchParams.delete('_fbc');
  url.searchParams.delete('_fbp');
  replaceUrl(url.pathname + url.search + url.hash);
  if (!fbc && !fbp) return;
  const prev = storedAdIds(storage, now) ?? {};
  try {
    storage.setItem(KEY, JSON.stringify({ fbc: fbc ?? prev.fbc, fbp: fbp ?? prev.fbp, at: now }));
  } catch {
    /* navegador sem armazenamento: segue sem os identificadores */
  }
}

/** Os identificadores guardados, se ainda valem (90 dias); senão, nada. */
export function storedAdIds(storage: Pick<Storage, 'getItem'> | undefined, now = Date.now()): AdIds | undefined {
  try {
    const raw = storage?.getItem(KEY);
    if (!raw) return undefined;
    const saved = JSON.parse(raw) as { fbc?: string; fbp?: string; at?: number };
    if (!saved.at || now - saved.at > MAX_AGE_MS) return undefined;
    const ids: AdIds = { fbc: valid(saved.fbc), fbp: valid(saved.fbp) };
    return ids.fbc || ids.fbp ? ids : undefined;
  } catch {
    return undefined;
  }
}

/** localStorage, quando o navegador deixa usar. */
export function browserStorage(): Storage | undefined {
  try {
    return globalThis.localStorage;
  } catch {
    return undefined;
  }
}
